import AdminNavigationLayout from 'shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import Button from 'shared/Buttons/Button/Button'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import { useSetRecoilState } from 'recoil'
import { useNavigate } from 'react-router-dom'
import projectTypesTableAtom from '../../components/ProjectTypesTable/projectTypesTable.atom'
import projectTypesApi from '../../projectTypes.api'
import ProjectTypeSheet from '../../components/ProjectTypeSheet'
import useStateWithChange from 'shared/hooks/useStateWithChange'

const CreateProjectTypePage = () => {
  const navigate = useNavigate()
  const { wait, loading } = useHttpLoader()
  const [draft, _setState, handleChange ] = useStateWithChange({ name: '', projectStages: [] })
  const setState = useSetRecoilState(projectTypesTableAtom)


  const handleSave = () => {
    wait(projectTypesApi.create(draft), (resp) => {
      if (resp.status === 'success') {
        setState((prev) => ({ ...prev, items: [resp.body, ...prev.items] }))
        navigate('/admin/project-types')
      }
    })
  }

  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='default'>
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
            <h2 className='page--header'>Создание типа проекта</h2>
          </div>
        </div>
        <ProjectTypeSheet projectType={draft} onChange={handleChange}>
          <Button theme='primary' loading={loading} onClick={handleSave} style={{ width: 'fit-content' }}>
            Создать
          </Button>
        </ProjectTypeSheet>
      </TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}

export default CreateProjectTypePage
